export const BREAKPOINTS = {
  MOBILE: {
    MAX_WIDTH: 767,
    MEDIA_QUERY: '@media (max-width: 767px)',
  },
  TABLET: {
    MIN_WIDTH: 768,
    MAX_WIDTH: 1279,
    MEDIA_QUERY: '@media (min-width: 768px) and (max-width: 1279px)',
  },
  DESKTOP: {
    MIN_WIDTH: 1280,
    MEDIA_QUERY: '@media (min-width: 1280px)',
  },
};
